import type { ComponentProps } from 'react';
import { Button } from '@lightning/ui/button';
import { cn } from '@/lib/utils';

export const HOWIE_ACTION_CONTROL_CLASS =
  'h-9 shrink-0 rounded-full border border-how-space-deep bg-how-space-deep px-4 font-body text-[13px] font-normal text-white shadow-none transition-colors hover:bg-how-space-mid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-how-space-deep/35 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-45';

type HowieActionButtonProps = ComponentProps<typeof Button>;

export function HowieActionButton({ className, ...props }: HowieActionButtonProps) {
  return <Button className={cn(HOWIE_ACTION_CONTROL_CLASS, className)} {...props} />;
}

